import AddIcon from '@mui/icons-material/Add';
import { Button, Stack, Toolbar, Typography } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import { useState } from 'react';
import AddAutomation from './addAutomation.component';
import { YouTube } from '@mui/icons-material';
import { CommonHelper } from 'src/utils/commonHelper';
import { useTranslation } from 'react-i18next';

const StyledRoot = styled(Toolbar)(({ theme }) => ({
  height: 96,
  display: 'flex',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1, 0, 3),
}));

export default function AutomationToolbar({ handleSuccess }) {
  const { t: translate } = useTranslation();
  const theme = useTheme();
  const isCustomDomain = CommonHelper.CustomDomain();
  const isPortalAdmin = CommonHelper.GetBrandInfoFromLocalStorage("is_portal_admin");
  const [openNewAutomationModel, setNewAutomationModel] = useState(false);
  const handleNewAutomationModal = () => {
    setNewAutomationModel(true);
  };
  const handleClose = () => {
    setNewAutomationModel(false);
  };
  return (
    <>
      <Stack direction="row" spacing={2} justifyContent="flex-end" alignItems="center">
        <Typography
          variant="body2"
          color="warning.main"
          sx={{ fontWeight: 600, mr: 2, display: 'flex', alignItems: 'center', whiteSpace: 'nowrap' }}
        >
          <span style={{ display: 'flex', alignItems: 'center', marginRight: 6 }}>
            <svg
              style={{ color: '#ed6c02', marginRight: 4 }}
              xmlns="http://www.w3.org/2000/svg"
              height="1.2em"
              viewBox="0 0 24 24"
              width="1.2em"
              fill="currentColor"
            >
              <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-2h2v2z" />
            </svg>
          </span>
          {translate(
            'automation.warning_cross_post',
            'Warning: Add cross post carefully. If the same account is added in new post, it may lead to duplicates.'
          )}
        </Typography>
        {(!isCustomDomain || isPortalAdmin) && (
          <Stack direction="row" spacing={2} alignItems="center">
            <Button
              variant="outlined"
              startIcon={<YouTube />}
              onClick={() =>
                window.open('https://www.youtube.com/watch?v=gdCAtom-LOE&ab_channel=Brand2Social', '_blank')
              }
              color="primary"
            >
              {translate('automation.tutorial', 'Tutorial')}
            </Button>
          </Stack>
        )}
        <StyledRoot>
          <Button variant="contained" startIcon={<AddIcon />} onClick={handleNewAutomationModal}>
            {translate('automation.add_new_cross_post', 'Add New Cross Post')}
          </Button>
        </StyledRoot>
      </Stack>

      {openNewAutomationModel && <AddAutomation handleClose={handleClose} handleSuccess={handleSuccess} />}
    </>
  );
}
